// src/routes/AppRoutes.tsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { routes, RouteConfig } from '../config/routes';
import { useAuth } from '../contexts/AuthContext';
import { GitHubCallback, GoogleCallback } from '../components/auth/OAuthCallback';

// --- Import the Layout component ---
import Layout from '../components/layout/Layout';


const AppRoutes: React.FC = () => {
  const { isSignedIn } = useAuth();
  const location = useLocation();

  return (
    <>
      <Routes>
        {/* Route Wrapper for pages WITH Header/Footer */}
        <Route element={<Layout />}>
        {routes.map((route: RouteConfig) => {
          if (route.protected) {
            return isSignedIn ? (
              <Route
                key={route.path}
                path={route.path}
                element={<route.element />}
              />
            ) : (
              <Route
                key={route.path}
                path={route.path}
                element={<Navigate to={`/signin?redirectTo=${encodeURIComponent(location.pathname)}`} />}
              />
            );
          } else if (!route.protected) {
            return (
              <Route
                key={route.path}
                path={route.path}
                element={<route.element />}
              />
            );
          } else {
            return null;
          }
        })}
        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/github/callback" element={<GitHubCallback />} />
        <Route path="/google/callback" element={<GoogleCallback />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
